import { ActionContext } from 'vuex';
import { Http } from '@integrai/ui';
import StateType from './state.type';

export default {
  async getClientInfo(context: ActionContext<StateType, {}>): Promise<void> {
    const { commit } = context || {};

    commit('toggleLoading', true);

    try {
      const client = await Http.get('client');

      commit('setClientInfo', client);
    } catch {
      commit('toggleLoading', false);
    }
  },
};
